import { ArrayUtils, engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { WinAnimator } from "../GameComponents/WinAnimator";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { Paylines } from "../GameComponents/Paylines";
import { Symbols } from "../GameComponents/Symbols";
import { Communication } from "neo-games";
import { Payline } from "../GameComponents/Payline";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { ITweenable, Tweens } from "../Components/Effects/Tweens";
import { Symbol } from "../GameComponents/Symbol";
import { PlayList } from "../Components/Sounds/PlayList";
import { PaylinesDefinitions } from "../GameComponents/PaylinesDefinitions";
import { StageController } from "../Components/StageController";
import { ModuleManager } from "../Managers/ModuleManager";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimator2 extends WinAnimator {
    public winShakes: number;
    // private _bg: SwitchElement;
    public winShakesRollY: Array<number>;
    public spinShakes: number;
    public spinShakesRollX: Array<number>;
    public bitmapMaskY: number;
    public bitmapMaskX: number;
    public reelsContainer: any;
    public teasing: any;
    public _bg: SwitchElement;
    public _logoReflection: SwitchElement;
    public _lights: ContainerElement;
    public _winFlowWin: ContainerElement;
    public _symbolLights: ContainerElement;
    public _flares: ContainerElement;
    protected glass: Element;
    protected idleID: number;
    private _multiplier: number;
    private currentIdleSteps: Array<any>;

    //******************************************************************************************************************
    //  CREATE, INITIALIZE
    //******************************************************************************************************************

    public initialize(
        symbols: Symbols,
        paylines?: Paylines,
        noWinSymbolsContainer?: ContainerElement,
        symbolsContainer?: ContainerElement,
        multipliers?: SwitchElement,
        glass?: ImageElement,
        frame?: ContainerElement,
        innerShadow?: ContainerElement,
        odlesk?: ContainerElement,
        teasing?: any,
        reels?: any,
        winFlowWin?: any,
        bg?: SwitchElement,
        lights?: ContainerElement,
        flares?: ContainerElement,
        symbolLights?: ContainerElement,
        logoReflection?: SwitchElement,
    ): void {
        this.createTimer();
        if (symbolLights != null) {
            this._symbolLights = symbolLights;
            this.addChild(symbolLights);
        }

        this.createSymbols(symbols, noWinSymbolsContainer, symbolsContainer);
        this.addChild(teasing);
        this.addChild(winFlowWin);
        this._winFlowWin = winFlowWin;
        this.addChild(innerShadow);
        if (lights != null) {
            this._lights = lights;
            this.addChild(lights);
        }

        if (logoReflection != null) {
            this._logoReflection = logoReflection;
        }

        this.addChild(glass);
        this.createPaylines(paylines);

        this.addChild(odlesk);

        this.addChild(frame);

        if (flares != null) {
            this._flares = flares;
            this.addChild(this._flares);
        }
        this.createAnimations();
        if (multipliers != null) {
            this._bg = multipliers;
        }
        if (reels != null) {
            this.reelsContainer = reels;
        }

        if (bg != null) {
            this._bg = bg;
        }
        this.teasing = teasing;

        this.idleID = -1;
    }

    public onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        super.onReelStopped(reelsData, reelIndex);

        if (this.checkDoubleFuits(reelsData, reelIndex)) {
            // if(reelIndex!=0) this._bg.goToCase('WIN1' + reelIndex)
        } else {
            this._bg.goToCase("OFF");
        }

        if (reelIndex == 2) {
            PlayList.stop("SND_BaseTeaser");
            PlayList.stop("SND_BaseTeaserStart");
        }
    }

    public checkDoubleFuits(stoppedSymbolsArray: Array<any>, reelIndex: number) {
        let allowedSymbolsForTeasing = [2, 3, 4, 5];
        let actualSymbol = 0;
        let isFruits = false;

        for (let i = 0; i <= reelIndex; i++) {
            if (
                stoppedSymbolsArray[i].symbols[0] == stoppedSymbolsArray[0].symbols[0] &&
                stoppedSymbolsArray[i].symbols[0] == stoppedSymbolsArray[i].symbols[1] &&
                stoppedSymbolsArray[i].symbols[0] == stoppedSymbolsArray[i].symbols[2] &&
                allowedSymbolsForTeasing.indexOf(stoppedSymbolsArray[i].symbols[0]) > -1
            ) {
                if (actualSymbol == 0) {
                    actualSymbol = stoppedSymbolsArray[i].symbols[0];
                }
                if (actualSymbol == stoppedSymbolsArray[i].symbols[0]) {
                    isFruits = true;
                }
            } else {
                return false;
            }
        }

        return isFruits;
    }

    public showWins(wins: Array<Communication.Game.IWin>, win: number, multiplier?: number, reels?: any): boolean {
        if (multiplier != null && multiplier > 1) {
            this._multiplier = multiplier;
        } else {
            this._multiplier = -1;
        }

        if (wins != null && wins.length > 0) {
            if (this._multiplier == -1) {
                this._bg.goToCase("WIN_NORMAL");
            } else {
                this._bg.goToCase("WIN12");
            }

            for (let i = 0; i < wins.length; i++) {
                const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                    wins[i].paylineId,
                    this.paylines.paylineDefinition,
                );
                for (let j = 0; j < definition.length; j++) {
                    let left = -1;
                    let right = -1;

                    left = definition[j] + j * 3;
                    right = left + 3;

                    let light: SwitchElement = <any>this._lights.children[left];
                    light.goToCase("WIN");

                    light = <any>this._lights.children[right];
                    light.goToCase("WIN");

                    light = <any>this._symbolLights.children[left];
                    light.goToCase("WIN");
                }
            }

            for (let i = 0; i < reels.children.length; i++) {
                if (reels.children[i].name != "ReelBG") {
                    let item = <any>reels.children[i];
                    item.tint = 0x676144;
                }
            }
        }

        return super.showWins(wins, win);
    }

    public reset(showLastSymbols: boolean): boolean {
        if (!showLastSymbols) {
            if (this._bg !== null) {
                if (
                    [
                        "IDLE0",
                        "IDLE1",
                        "IDLE2",
                        "WIN",
                        "WIN_NORMAL",
                        "WIN_NORMAL_CYCLE",
                        "ON",
                        "WIN11",
                        "WIN12",
                        "CYCLE",
                    ].indexOf(this._bg.getCurrentCase()) !== -1
                ) {
                    this._bg.goToCase("TOOFF");
                }
            }
        } else {
            if (this._bg !== null) {
                if (
                    ["WIN", "WIN_NORMAL", "WIN_NORMAL_CYCLE", "ON", "CYCLE"].indexOf(this._bg.getCurrentCase()) !== -1
                ) {
                    this._bg.goToCase("TOOFF");
                }
            }
        }

        if (this._logoReflection != null) {
            this._logoReflection.goToCase("NORMAL");
        }

        if (this._winFlowWin != null) {
            for (let i = 0; i < this._winFlowWin.children.length; i++) {
                let winFlow: SwitchElement = <any>this._winFlowWin.children[i];
                winFlow.goToCase("NORMAL");
            }
        }
        if (this._lights != null) {
            for (let i = 0; i < this._lights.children.length; i++) {
                let flare: SwitchElement = <any>this._lights.children[i];
                flare.goToCase("NORMAL");
            }
        }

        if (this._symbolLights != null) {
            for (let i = 0; i < this._symbolLights.children.length; i++) {
                let flare: SwitchElement = <any>this._symbolLights.children[i];
                flare.goToCase("NORMAL");
            }
        }

        PlayList.stop("SND_BaseX2");

        for (let i = 0; i < this.reelsContainer.children.length; i++) {
            if (this.reelsContainer.children[i].name != "ReelBG") {
                let item = <any>this.reelsContainer.children[i];
                item.tint = 0xffffff;
            }
        }

        return super.reset(showLastSymbols);
    }

    protected configure(node: Element): void {
        super.configure(node);

        if (node.hasAttribute("WinShakes")) {
            this.winShakes = parseInt(node.getAttribute("WinShakes"));
        }

        if (node.hasAttribute("WinShakesRollY")) {
            this.winShakesRollY = ArrayUtils.numberArray(node.getAttribute("WinShakesRollY"), ";");
        }

        if (node.hasAttribute("BitmapMaskX")) {
            this.bitmapMaskX = parseFloat(node.getAttribute("BitmapMaskX"));
        }
        if (node.hasAttribute("BitmapMaskY")) {
            this.bitmapMaskY = parseFloat(node.getAttribute("BitmapMaskY"));
        }

        if (node.hasAttribute("SpinShakes")) {
            this.spinShakes = parseInt(node.getAttribute("SpinShakes"));
        }

        if (node.hasAttribute("SpinShakesRollX")) {
            this.spinShakesRollX = ArrayUtils.numberArray(node.getAttribute("SpinShakesRollX"), ";");
        }
    }

    protected stopAnimation() {
        super.stopAnimation();

        let another: Array<any> = [];

        if (this.noWinSymbolsContainer && this.noWinSymbolsContainer.children.length > 0) {
            for (let j = 0; j < this.noWinSymbolsContainer.children.length; j++) {
                another.push(this.noWinSymbolsContainer.children[j]);
            }
        }

        if (this.symbolsContainer && this.symbolsContainer.children.length > 0) {
            for (let j = 0; j < this.symbolsContainer.children.length; j++) {
                another.push(this.symbolsContainer.children[j]);
            }
        }

        for (let i = 0; i < another.length; i++) {
            Tweens.removeTweens(another[i].children[0], "position");
            another[i].children[0].position.x = 0;
            another[i].children[0].position.y = 0;
        }
    }

    protected finishFirstWins(): void {
        super.finishFirstWins();

        let another: Array<any> = [];

        if (this.noWinSymbolsContainer.children.length > 0) {
            for (let j = 0; j < this.noWinSymbolsContainer.children.length; j++) {
                another.push(this.noWinSymbolsContainer.children[j]);
            }
        }

        if (this.symbolsContainer.children.length > 0) {
            for (let j = 0; j < this.symbolsContainer.children.length; j++) {
                another.push(this.symbolsContainer.children[j]);
            }
        }

        for (let i = 0; i < another.length; i++) {
            Tweens.removeTweens(another[i].children[0], "position");
            another[i].children[0].position.x = 0;
            another[i].children[0].position.y = 0;
        }
    }

    protected createPaylines(paylines: Paylines): void {
        this.paylines = paylines;
        this.allPaylinesGoToCase(Payline.CaseNormal);
        this.paylines.showPaylinesLabel();

        this.addChild(this.paylines);
    }

    protected createSymbols(
        symbols: Symbols,
        noWinSymbolsContainer: ContainerElement,
        symbolsContainer: ContainerElement,
    ): void {
        this.symbols = symbols;

        let container: ContainerElement = new ContainerElement();

        container.name = "SymbolsContainer";

        if (noWinSymbolsContainer != null) {
            this.noWinSymbolsContainer = noWinSymbolsContainer;
        } else {
            this.noWinSymbolsContainer = new ContainerElement();
            this.noWinSymbolsContainer.name = "NoWinSymbols";
        }

        if (symbolsContainer != null) {
            this.symbolsContainer = symbolsContainer;
        } else {
            this.symbolsContainer = new ContainerElement();
            this.symbolsContainer.name = "Symbols";
        }

        if (!(StageController.Renderer instanceof PIXI.CanvasRenderer)) {
            let image = StageController.getTextureByResourceId("GFX_reelsMask");
            container.maskSprite = new PIXI.Sprite(image);
            container.maskSprite.position.x = this.bitmapMaskX;
            container.maskSprite.position.y = this.bitmapMaskY;
            container.addChild(container.maskSprite);
            container.mask = container.maskSprite;
        }

        container.addChild(this.symbolsContainer);
        container.addChild(this.noWinSymbolsContainer);

        this.addChild(container);

        this.currentSymbols = [];

        for (let i = 0; i < this.reelCount; i++) {
            this.currentSymbols.push([]);

            for (let j = 0; j < this.symbolCount; j++) {
                this.currentSymbols[i].push(null);
            }
        }
    }

    protected allSymbolsGoToReset(): void {
        super.allSymbolsGoToReset();

        // const caseType = 'OFF';
        // const bg = this._bg;
        //
        // if (bg !== null) {
        //     const currentCaseType = bg.getCurrentCase();
        //
        //     if (caseType !== currentCaseType && ['IDLE0','IDLE1','IDLE2'].indexOf(currentCaseType) === -1) {
        //         bg.goToCase(currentCaseType);
        //     }
        // }
    }

    protected showCustomWin(): boolean {
        if (this._multiplier > 1) {
            this.currentAnimationIndex = this.getAnimationIndex();
            this.currentAnimationFinished = false;

            if (this._bg != null && this._multiplier > 1) {
                PlayList.play("SND_BaseReelsShake");
                PlayList.stop("SND_BaseLoop");

                this._bg.goToCase("WIN12");

                for (let i = 0; i < this.currentWins.length; i++) {
                    this.winPaylineGoToCase(i, Payline.CaseFirstWin);
                }

                this.allSymbolsGoToCase("SINGLEWIN", false);

                let symbolsArray: Array<any> = [];
                let reelX = this.reelX;
                for (let i = 0; i < this.reelCount; i++) {
                    let another: Array<any> = [];

                    if (this.noWinSymbolsContainer.children.length > 0) {
                        for (let j = 0; j < this.noWinSymbolsContainer.children.length; j++) {
                            if (this.noWinSymbolsContainer.children[j].x == reelX[i]) {
                                another.push(this.noWinSymbolsContainer.children[j]);
                            }
                        }
                    }

                    if (this.symbolsContainer.children.length > 0) {
                        for (let j = 0; j < this.symbolsContainer.children.length; j++) {
                            if (this.symbolsContainer.children[j].x == reelX[i]) {
                                another.push(this.symbolsContainer.children[j]);
                            }
                        }
                    }
                    symbolsArray.push(another);
                }

                if (this.winShakes != 0) {
                    for (let i = 0; i < symbolsArray.length; i++) {
                        for (let j = 0; j < symbolsArray[i].length; j++) {
                            let symbol: ITweenable = <any>symbolsArray[i][j].children[0];

                            let coords: Array<any> = [];
                            let number = 0;
                            if (this.winShakesRollY.length > 1) {
                                number =
                                    Math.random() * (this.winShakesRollY[1] - this.winShakesRollY[0]) +
                                    this.winShakesRollY[0];
                            } else {
                                number = this.winShakesRollY[0];
                            }

                            if (i % 2 == 1) number *= -1;

                            coords.push({ x: symbol.position.x, y: symbol.position.y });

                            for (let k = 0; k < this.winShakes; k++) {
                                if (k % 2 == 1) number *= -1;
                                coords.push({ x: symbol.position.x, y: symbol.position.y + number });
                            }
                            coords.push({ x: symbol.position.x, y: symbol.position.y });

                            Tweens.removeTweens(symbol, "position");
                            Tweens.positionTween(symbol, {
                                bezier: {
                                    values: coords,
                                },
                                tweenX: [symbol.position.x, symbol.position.x],
                                tweenY: [symbol.position.y, symbol.position.y],
                                tweenDuration: 30,
                                tweenDelay: 20,
                                tweenLoop: true,
                            });
                        }
                    }
                }
            }
            PlayList.play("SND_BaseWinReel");
            this.startTimer("Multiplier", 120);

            return true;
        }

        return false;
    }

    protected getCycleWinsDelay(): number {
        return 120;
    }

    protected cycleWins(): void {
        if (this.currentWins == null) {
            return;
        }

        PlayList.play("SND_BaseRecapWinline");

        this.allPaylinesGoToCase(Payline.CaseNowin);
        this.allSymbolsGoToCase(Symbol.CaseNowin, true);

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winPaylineGoToCase(i, Payline.CaseNormal);
        }

        for (let i = 0; i < this._lights.children.length; i++) {
            let light: SwitchElement = <any>this._lights.children[i];
            light.goToCase("NORMAL");
        }

        for (let i = 0; i < this._symbolLights.children.length; i++) {
            let light: SwitchElement = <any>this._symbolLights.children[i];
            light.goToCase("NORMAL");
        }

        const definition = PaylinesDefinitions.getPaylineDefinitionsById(
            this.currentWins[this.currentCycle].paylineId,
            this.paylines.paylineDefinition,
        );
        for (let j = 0; j < definition.length; j++) {
            let left = -1;
            let right = -1;

            left = definition[j] + j * 3;
            right = left + 3;

            let light: SwitchElement = <any>this._lights.children[left];
            light.goToCase("CYCLE");

            light = <any>this._lights.children[right];
            light.goToCase("CYCLE");

            light = <any>this._symbolLights.children[left];
            light.goToCase("CYCLE");
        }
        this._bg.goToCase("OFF");

        if (this._multiplier >= 2) {
            this._bg.goToCase("CYCLE");
        } else {
            this._bg.goToCase("WIN");
        }
        this.winSymbolsGoToCase(this.currentCycle, Symbol.CaseCycle, true);
        this.winPaylineGoToCase(this.currentCycle, Payline.CaseWin);
        this.currentCycle = (this.currentCycle + 1) % this.currentWins.length;

        this.startTimer(WinAnimator.CycleWins, this.getCycleWinsDelay());
    }

    protected showFirstWins(): void {
        // PlayList.stop('SND_BaseLoop');
        PlayList.stop("SND_BaseX2");

        this.allSymbolsGoToCase(Symbol.CaseNowin, true);
        // this.allPaylinesGoToCase(Payline.CaseNowin);

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            if (this._multiplier <= 1) this.winPaylineGoToCase(i, Payline.CaseFirstWin);
        }

        let another: Array<any> = [];
        if (this.noWinSymbolsContainer.children.length > 0) {
            for (let j = 0; j < this.noWinSymbolsContainer.children.length; j++) {
                another.push(this.noWinSymbolsContainer.children[j]);
            }
        }

        if (this.symbolsContainer.children.length > 0) {
            for (let j = 0; j < this.symbolsContainer.children.length; j++) {
                another.push(this.symbolsContainer.children[j]);
            }
        }

        for (let i = 0; i < another.length; i++) {
            Tweens.removeTweens(another[i].children[0], "position");
            another[i].children[0].position.x = 0;
            another[i].children[0].position.y = 0;
        }
        this._logoReflection.goToCase("NORMAL");

        this.startAnimation();
    }

    protected getInitialIdleDelay(): number {
        return 240;
    }

    protected getIdleDelay(): number {
        return 120;
    }

    protected idle(): void {
        let number: number = Math.random() * 2;
        if (this.idleID == Math.floor(number)) {
            this.idleID = Math.ceil(number);
        } else {
            this.idleID = Math.floor(number);
        }

        if (!ModuleManager.gambleActive()) {
            this._bg.goToCase("IDLE" + this.idleID);
        }

        super.idle();
    }

    protected onTimerComplete(): void {
        this.timer.stop();

        switch (this.timerStatus) {
            case WinAnimator.Idle:
                this.idle();
                break;
            case WinAnimator.CycleWins:
                this.cycleWins();
                break;
            case "Multiplier":
                this.showFirstWins();
                break;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimator2.ts
 **/